import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './key-feature-card.scss.js';
import '../../atoms/buttons/enums.js';
import { wrapRichTextTables } from '../../utilities/dom-helpers/index.js';
import '../../atoms/buttons/generic-button2.0/index.js';
import '../../atoms/generic-image/index.js';

class KeyFeatureCard extends s {
    constructor() {
        super(...arguments);
        this.cardId = '';
        this.imageUrl = '';
        this.imageAltText = '';
        this.imageDecorative = '';
        this.title = '';
        this.body = '';
        this.isRtl = false;
        this.index = 0;
    }
    generateGenericButton() {
        var _a;
        if (!this.cta) {
            return '';
        }
        const ctaLabel = this.cta.title || '';
        const ctaHref = this.cta.url;
        const ctaTarget = this.cta.target || '_self';
        const ctaStyleType = 'light';
        const ctaType = 'tertiary';
        const ctaColor = 'purple';
        const ariaListValue = ((_a = this.cta.ariaLabel) === null || _a === void 0 ? void 0 : _a.trim())
            ? { label: this.cta.ariaLabel }
            : {};
        const ctaClass = `cta-link cta-link--${ctaType}-button key-feature-card-button`;
        return $ `<generic-button-updated type="${ctaType}" .label="${ctaLabel}" .href="${ctaHref}" .target="${ctaTarget}" .styleType="${ctaStyleType}" .color="${ctaColor}" ?isNoFollow="${this.cta.isNoFollow || false}" .ariaList="${ariaListValue}" ?rtl="${this.isRtl}" class="${ctaClass}"></generic-button-updated>`;
    }
    render() {
        const rtlClass = this.isRtl ? ' rtl' : '';
        const dirAttr = this.isRtl ? 'rtl' : 'ltr';
        return $ `<article id="${this.cardId}" class="key-features-card${rtlClass}" dir="${dirAttr}"><div class="simple-card"><generic-image src="${this.imageUrl}" alt="${this.imageAltText}" decorative="${this.imageDecorative}" aspect-ratio="16:9" loading="lazy" class="generic-image-key-feature-plus"></generic-image><div class="content${rtlClass}"><h3 class="key-features-card-title${rtlClass}">${o(this.title)}</h3><div class="key-features-card-description${rtlClass} rte${this.isRtl ? ' rte--rtl' : ''}">${o(wrapRichTextTables(this.body))}</div>${this.generateGenericButton()}</div></div></article>`;
    }
}
KeyFeatureCard.styles = css_248z;
__decorate([
    e({ type: String })
], KeyFeatureCard.prototype, "cardId", void 0);
__decorate([
    e({ type: String })
], KeyFeatureCard.prototype, "imageUrl", void 0);
__decorate([
    e({ type: String })
], KeyFeatureCard.prototype, "imageAltText", void 0);
__decorate([
    e({ type: String })
], KeyFeatureCard.prototype, "imageDecorative", void 0);
__decorate([
    e({ type: String })
], KeyFeatureCard.prototype, "title", void 0);
__decorate([
    e({ type: String })
], KeyFeatureCard.prototype, "body", void 0);
__decorate([
    e({ type: Object })
], KeyFeatureCard.prototype, "cta", void 0);
__decorate([
    e({ type: Boolean })
], KeyFeatureCard.prototype, "isRtl", void 0);
__decorate([
    e({ type: Number })
], KeyFeatureCard.prototype, "index", void 0);
customElements.define('key-feature-card', KeyFeatureCard);

export { KeyFeatureCard };
